var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNikon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nikon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient01",
    gradientUnits: "userSpaceOnUse",
    x1: 481.7688,
    y1: -363.7171,
    x2: 488.8338,
    y2: -365.8058,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient02",
    gradientUnits: "userSpaceOnUse",
    x1: 482.3754,
    y1: -364.3647,
    x2: 489.1586,
    y2: -366.57,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient03",
    gradientUnits: "userSpaceOnUse",
    x1: 482.9458,
    y1: -364.9744,
    x2: 489.4694,
    y2: -367.2999,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient04",
    gradientUnits: "userSpaceOnUse",
    x1: 483.4862,
    y1: -365.5518,
    x2: 489.7654,
    y2: -368,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient05",
    gradientUnits: "userSpaceOnUse",
    x1: 484.0045,
    y1: -366.1029,
    x2: 490.0534,
    y2: -368.6767,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient06",
    gradientUnits: "userSpaceOnUse",
    x1: 484.5003,
    y1: -366.6295,
    x2: 490.3333,
    y2: -369.3334,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient07",
    gradientUnits: "userSpaceOnUse",
    x1: 484.9738,
    y1: -367.1339,
    x2: 490.6053,
    y2: -369.9736,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient08",
    gradientUnits: "userSpaceOnUse",
    x1: 485.4353,
    y1: -367.6225,
    x2: 490.873,
    y2: -370.602,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient09",
    gradientUnits: "userSpaceOnUse",
    x1: 485.8909,
    y1: -368.1044,
    x2: 491.1303,
    y2: -371.2216,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient10",
    gradientUnits: "userSpaceOnUse",
    x1: 486.3512,
    y1: -368.5891,
    x2: 491.3969,
    y2: -371.847,
    gradientTransform: "matrix(77.3572 0 0 77.3572 -37500.6562 28577.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEC59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE419"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient01)",
    d: "M303.055,283.241c-88.936,15.696-177.988,36.567-266.773,62.811C24.138,349.643,12.042,353.323,0,357.088 v31.352c15.009-4.127,30.018-8.408,45.018-12.84C133.797,349.347,219.883,318.437,303.055,283.241z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient02)",
    d: "M328.305,224.411c-85.362,18.158-170.783,40.988-255.911,68.666C48.045,300.992,23.91,309.243,0,317.822 v26.398c27.002-7.795,53.987-16.072,80.944-24.836C166.069,291.706,248.589,259.927,328.305,224.411z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient03)",
    d: "M352.505,168.243c-82.116,20.282-164.225,44.924-245.993,74.075C70.501,255.156,34.991,268.711,0,282.959 V304.5c38.423-11.694,76.809-24.36,115.12-38.015C196.888,237.331,276.073,204.477,352.505,168.243z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient04)",
    d: "M375.6,114.373c-79.037,22.419-158.02,48.891-236.619,79.533C91.72,212.332,45.383,231.964,0,252.73v15.81 c49.29-15.909,98.515-33.415,147.6-52.548C226.19,185.347,302.257,151.368,375.6,114.373z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient05)",
    d: "M397.862,62.404c-76.136,24.571-152.172,52.898-227.795,85.076C111.877,172.242,55.165,198.754,0,226.894 v9.334c59.685-20.549,119.273-43.419,178.613-68.665C254.23,135.384,327.37,100.228,397.862,62.404z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient06)",
    d: "M400,23.069V19.19c-66.824,24.93-133.52,52.75-199.866,83.501C131.206,134.646,64.45,168.936,0,205.332 v2.218c69.723-25.748,139.323-54.632,208.545-86.716C274.383,90.312,338.232,57.655,400,23.069z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient07)",
    d: "M25.517,172.214c70.84-28.989,141.541-61.179,211.831-96.617C285.268,51.431,332.101,26.198,377.795,0 h-23.881c-41.695,18.654-83.307,38.428-124.771,59.334C158.864,94.773,90.939,132.491,25.517,172.214z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient08)",
    d: "M60.879,134.162c68.341-31.261,136.559-65.454,204.378-102.608C284.179,21.185,302.921,10.665,321.49,0 h-32.454c-10.568,5.635-21.131,11.346-31.682,17.13C189.537,54.286,124.001,93.382,60.879,134.162z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient09)",
    d: "M272.151,0h-27.883C193.448,31.192,143.995,63.353,95.987,96.363C154.851,66.382,213.641,34.264,272.151,0z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient10)",
    d: "M231.041,0h-17.579c-27.88,19.273-55.307,38.793-82.272,58.539C164.504,39.694,197.803,20.182,231.041,0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#150301",
    d: "M144.981,385.399l21.598-97.315l26.617,0.003l-11.603,51.759l21.499-25.953h29.761l-26.706,32.446 l11.01,39.061H190.6l-10.976-37.009l-8.693,37.009H144.981z M48.872,336.484l18.754,48.914h25.509l21.983-97.315l-26.273,0.003 l-11.121,49.501L59.32,288.055H32.683l-21.718,97.344h26.788C40.794,369.802,44.864,353.329,48.872,336.484z M132.235,385.399 l15.935-71.467h-26.144l-15.932,71.467H132.235z M123.366,298.275c0,2.243,0.527,10.172,14.835,10.172 c11.885,0,16.468-7.616,16.468-13.302c0-3.828-3.129-10.471-14.841-10.471C129.04,284.675,123.366,291.888,123.366,298.275z M374.819,312.968c-11.178-3.329-25.03,2.194-31.867,11.657c0.664-2.933,1.374-6.344,2.177-10.272H318.6l-15.525,71.046h26.401 l8.807-40.296c1.619-7.416,7.582-10.585,12.863-9.22c2.277,0.616,5.409,2.337,4.372,8.516l-8.961,40.999h26.09l11.959-54.717 C387.14,318.622,377.236,313.692,374.819,312.968z M286.046,378.954c11.461-9.372,17.129-25.218,16.947-40.127 c-0.194-14.33-12.33-27.923-33.443-27.923c-40.247,0-46.101,31.371-47.264,37.097c-2.947,14.484,0.331,33.284,19.236,38.266 C253.996,389.56,273.502,389.203,286.046,378.954z M256.521,337.533c1.892-5.213,7.043-6.367,9.371-6.39 c5.769-0.049,7.348,3.372,6.846,6.595c-1.388,8.935-4.483,20.273-5.626,23.887c-0.014,0.048-0.023,0.094-0.037,0.134 c-1.257,3.947-4.976,6.245-9.354,6.245c-4.432,0-7.111-2.787-6.729-6.339C251.642,355.669,255.438,340.512,256.521,337.533z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikon);
export default __webpack_public_path__ + "static/media/nikon.c08400e7c012a80d32b0f57bdf37aefb.svg";
export { ForwardRef as ReactComponent };